import globals from '../../../common/globals';

/**
 * Live Chat Component
 */

/* eslint-disable */
export default {
  name: 'vx-live-chat',
  props: {
    // Text and label from properties file
    i18n: {
      type: Object,
      required: true,
    },
    // Dynamic css class for live chat
    liveChatTheme: {
      type: String,
      required: false,
    },
    // Shows call us section
    showContactUs: {
      type: Boolean,
      required: true,
      default: true,
    },
    // Data about chat section
    imageTextData: {
      type: Object,
      required: false,
    },
    // Indicates if live chat section is enabled on contact us page
    isLiveChatEnabled: {
      type: Boolean,
      default: false,
      required: true,
    },
    // Contact email to be passed from jsp
    contactUsEmail: {
      type: String,
      default: '',
      required: false,
    }
  },
  data() {
    return {
      liveAgentConfig: globals.thirdPartyApps.liveAgent,
      globals,
      showButtons: false,
      splitParam: new RegExp(':\\s*'),
    };
  },
  computed: {
    callNumber() {
      return this.i18n.callNumber.split(this.splitParam)[1];
    },
    textNumber() {
      return this.i18n.textNumber.split(this.splitParam)[1];
    },
  },
  created() {
    // Checking if live chat has been enabled or not
    if (this.isLiveChatEnabled) {
      // Initializing live chat
      liveagent.init(
        this.liveAgentConfig.endPoint,
        this.liveAgentConfig.orgId,
        this.liveAgentConfig.deploymentId,
      );
    }
  },
  async mounted() {
    if (this.isLiveChatEnabled) {
      const self = this;
      if (!window._laq) {
        window._laq = [];
      }
      window._laq.push(function () {
        liveagent.showWhenOnline(
          self.liveAgentConfig.buttonId,
          self.$refs.chatOnline,
        );
        liveagent.showWhenOffline(
          self.liveAgentConfig.buttonId,
          self.$refs.chatOffline,
        );
      });
      // Pre populating the fields in the chat window for logged in user
      if (this.globals.getIsLoggedIn()) {
        liveagent.addCustomDetail('UserFirstName', this.globals.userInfo.firstName);
        liveagent.addCustomDetail('UserLastName', this.globals.userInfo.lastName);
        liveagent.addCustomDetail('UserEmail', this.globals.userInfo.email);
        liveagent.addCustomDetail('UserCompany', this.globals.userInfo.unit);
        liveagent.addCustomDetail('UserPhone', this.globals.userInfo.contactNumber);
      }
    }
  },
  methods: {
    /**
     * Triggers the salesforce chat window
     * @param {*} event
     */
    triggerChat(event) {
      liveagent.startChat(this.liveAgentConfig.buttonId);
    },
  },
};
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/components/b2c/access-customer-service/vx-live-chat/vx-live-chat.js